import axios from 'axios'
import MobileHeroSettingsService from '@frontend/services/api/mobile-hero-settings'

export default {
  namespaced: true,

  state: () => ({
    settings: [],
    currentSetting: null,
    loading: false,
    error: null
  }),

  getters: {
    settings: state => state.settings,
    currentSetting: state => state.currentSetting,
    loading: state => state.loading,
    error: state => state.error
  },

  mutations: {
    SET_SETTINGS(state, payload) {
      state.settings = payload
    },
    SET_CURRENT_SETTING(state, payload) {
      state.currentSetting = payload
    },
    ADD_SETTING(state, payload) {
      state.settings.push(payload)
    },
    UPDATE_SETTING(state, payload) {
      const index = state.settings.findIndex(setting => setting.id === payload.id)
      if (index !== -1) {
        state.settings.splice(index, 1, payload)
      }
    },
    REMOVE_SETTING(state, id) {
      state.settings = state.settings.filter(setting => setting.id !== id)
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchSettings({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await MobileHeroSettingsService.list()
        commit('SET_SETTINGS', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to fetch settings')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchSetting({ commit }, id) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await MobileHeroSettingsService.get(id)
        commit('SET_CURRENT_SETTING', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to fetch setting')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createSetting({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await MobileHeroSettingsService.create(payload)
        commit('ADD_SETTING', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to create setting')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateSetting({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await MobileHeroSettingsService.update(payload)
        commit('UPDATE_SETTING', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to update setting')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteSetting({ commit }, id) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        await MobileHeroSettingsService.delete(id)
        commit('REMOVE_SETTING', id)
        return true
      } catch (error) {
        commit('SET_ERROR', error.message || 'Failed to delete setting')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
